package org.gymly.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.decodeToImageBitmap
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.gymly.model.PickedImagePayload
import org.gymly.theme.GymlyColors

/**
 * Comprobante adjunto: si es imagen, se muestra la vista previa; si es PDF u otro archivo, su nombre.
 * Permite cambiarlo o quitarlo antes de enviar.
 */
@Composable
fun ProofPreview(
    payload: PickedImagePayload?,
    fileName: String?,
    enabled: Boolean,
    onPick: () -> Unit,
    onRemove: () -> Unit,
) {
    val bitmap = remember(payload) {
        payload
            ?.takeIf { it.mimeType.startsWith("image/") }
            ?.bytes
            ?.takeIf { it.isNotEmpty() }
            ?.let { bytes -> runCatching { bytes.decodeToImageBitmap() }.getOrNull() }
    }
    Column(Modifier.fillMaxWidth()) {
        if (bitmap != null) {
            Image(
                bitmap = bitmap,
                contentDescription = "Vista previa del comprobante",
                modifier = Modifier
                    .fillMaxWidth()
                    .height(220.dp)
                    .clip(RoundedCornerShape(10.dp))
                    .background(GymlyColors.SurfaceContainer),
                contentScale = ContentScale.Fit,
            )
            Spacer(Modifier.height(6.dp))
        }
        fileName?.let {
            Text(it, color = GymlyColors.TextMuted, fontSize = 12.sp, maxLines = 1)
        }
        Row(
            Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            TextButton(onClick = onPick, enabled = enabled) {
                Text(
                    if (fileName == null) "Adjuntar comprobante" else "Cambiar comprobante",
                    color = GymlyColors.Primary,
                    fontWeight = FontWeight.SemiBold,
                )
            }
            if (fileName != null) {
                TextButton(onClick = onRemove, enabled = enabled) {
                    Text("Quitar", color = GymlyColors.Error, fontWeight = FontWeight.SemiBold)
                }
            }
        }
    }
}
